import type { WozQuestionType } from '@footsteps/types';

/**
 * Entity mirroring `case_complaint_questions` + joined question definition.
 */
export class WozCaseComplaintQuestionEntity {
  id: string | null;
  sequence: number;
  questionId: string;
  question: string;
  type: WozQuestionType;
  action: string | null;
  order: number;
  options: { id: string; caption: string; order: number }[];
  answer: string | string[] | Record<string, unknown> | Record<string, unknown>[] | null;

  constructor(data: Partial<WozCaseComplaintQuestionEntity> = {}) {
    this.id = data.id ?? null;
    this.sequence = data.sequence ?? 0;
    this.questionId = data.questionId ?? '';
    this.question = data.question ?? '';
    this.type = data.type ?? 'open';
    this.action = data.action ?? null;
    this.order = data.order ?? 0;
    this.options = data.options ?? [];
    this.answer = data.answer ?? null;
  }

  toJSON() {
    return {
      id: this.id,
      sequence: this.sequence,
      questionId: this.questionId,
      question: this.question,
      type: this.type,
      action: this.action,
      order: this.order,
      options: this.options,
      answer: this.answer,
    };
  }
}
